<template>
    <div class="apprentice-simple-card">
        <div class="component-title">
            <h5 class="title">{{ $t('testcenter.testcenter') }}</h5>
        </div>

        <ul class="active-tests">
            <li
                class="test-link"
                v-for="response in testResponsesIn.slice(0, 5)"
                :key="response.id">
                <b-button
                    class="btn-test-link"
                    variant="link"
                    :class="{ finished: response.is_submitted }"
                    @click="getTestLink(response)">
                    {{ response.test_issuing.test.title }}
                </b-button>
            </li>
        </ul>

        <div
            class="show-more"
            v-if="testResponsesIn.lengh > 5">
            <b-button
                class="btn-show-all btn-show-more-issuing-test"
                variant="primary"
                @click="toTestCenter">
                meer
            </b-button>
        </div>

        <design-2021-test-center-results-modal-component
            :show-graph="false"
            :test-issuing-in="{}"
            ref="results">
        </design-2021-test-center-results-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-test-center-widget-component',
    props: {
        testResponsesIn: {
            type: Array,
            required: true,
        },
    },
    methods: {
        toTestCenter() {
            return this.routes.testCenter();
        },

        getTestLink(response) {
            if (response.is_submitted) {
                this.$refs.results.show(response);
            } else {
                window.location.href = this.routes.testResponse(response.id);
            }
        },
    },
};
</script>

<style scoped lang="scss">
.active-tests {
    list-style: none;
    padding: 0;
}

.btn-test-link {
    font-size: $default-font-size;
    line-height: 1;

    &:before {
        content: '\f7f3';
        display: inline-block;
        font-family: 'Font Awesome 5 Pro';
        margin-right: map-get($grid-padding-spacing, 'four');
        width: 1.25em;
        color: $warning;
    }

    &.finished {
        &:before {
            content: '\f00c';
            color: $success;
        }
    }
}
</style>
